// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PatientSelectionDialog_wrapper__edNF9","patientSelectBtn":"PatientSelectionDialog_patientSelectBtn__2KwFP","buttons":"PatientSelectionDialog_buttons__ks2pl"};